<template>
  <div :qaid="`project-one-${currentRoute}-view`">
    <project-one-rail-layout :base-properties="bpData" @on-backpress="$emit('on-backpress')" />
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import ProjectOneRailLayout from '@/projectOne/components/rightRail/ProjectOneRailLayout';

export default {
  components: {ProjectOneRailLayout},

  computed: {
    ...mapState('projectOne', ['currentRoute', 'moduleGroups']),
  },

  created() {
    this.fetchModule({buildId: this.$route.params.buildId, module: this.currentRoute}).then(() => {
      const railConfig = {
        content: {
          isRootModuleGroups: true,
        },
      };

      this.clearRailDataStack();
      this.pushToRailDataStack(railConfig);

      this.$nextTick(() => {
        this.calculateApplicationHeight();
      });
    });
  },

  methods: {
    ...mapActions('projectOne', ['fetchModule', 'proceedToNextStep']),
    ...mapMutations('projectOne', ['pushToRailDataStack', 'clearRailDataStack', 'calculateApplicationHeight']),
  },
};
</script>
